<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">订货汇总</li>
                <li @click="orderjump(2)">订单统计</li>
                <li class="active">分类统计</li>
                <li @click="orderjump(4)">品牌统计</li>
            </ul>
        </div>
        <div class="summary_search_content">
            <div class="summary_search_left">
                <div class="order_search_list">
                    <DatePicker type="date" format="yyyy-MM-dd" :value="stardatetiem" placeholder="开始时间" :clearable="false" @on-change="starChange" style="width: 148px;"></DatePicker>
                    <span class="order_search_spacer">~</span>
                    <DatePicker type="date" format="yyyy-MM-dd" :value="enddatetiem" placeholder="结束时间" :clearable="false" @on-change="endChange" style="width: 148px;"></DatePicker>
                </div>
                <div class="export_excel_btn" @click="orderdownclick"><i class="icon iconfont icon-excel"></i>导出Excel</div>
            </div>
        </div>
        <div class="orderdetails_table_content">
            <Table
                border
                ref="selection"
                :loading="tloading"
                :columns="thead"
                :data="infolist"></Table>
        </div>
        <!-- 分页 -->
        <div class="page_content">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
let dates = new Date()
export default {
    data() {
        return {
            tloading: false, // 表格加载中
            stardatetiem: '', // 开始时间
            enddatetiem: '', // 结束时间
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: '40px',
                    align: 'center'
                },
                {
                    align: 'center',
                    title: '商品分类',
                    key: 'catidname'
                },
                {
                    align: 'center',
                    title: '订货数量',
                    key: 'ordernum',
                    renderHeader: (h, params) => {
                        return h('div',
                                    [
                                        h('span', params.column.title),
                                        h('Poptip',
                                            {
                                                style: {
                                                    width: 'auto',
                                                    marginLeft: '6px',
                                                    display: 'inline-block',
                                                    verticalAlign: 'text-bottom',
                                                    fontWeight: 'normal',
                                                },
                                                props: {
                                                    trigger: 'hover',
                                                    content: '统计时间内客户下单的商品分类数量（不含已取消的订货单）',
                                                    offset: 6,
                                                }
                                            },
                                            [
                                                h('Icon',
                                                    {
                                                        style: {
                                                            fontSize: '16px',
                                                            color: '#c4c6cc',
                                                            cursor: 'pointer'
                                                        },
                                                        props: {
                                                            type: 'md-help-circle'
                                                        }
                                                    }
                                                )
                                            ]
                                        )
                                    ]
                                    
                                )
                    }
                },
                {
                    align: 'center',
                    title: '订货金额',
                    key: 'ordersubtotal',
                    renderHeader: (h, params) => {
                        return h('div',
                                    [
                                        h('span', params.column.title),
                                        h('Poptip',
                                            {
                                                style: {
                                                    width: 'auto',
                                                    marginLeft: '6px',
                                                    display: 'inline-block',
                                                    verticalAlign: 'text-bottom',
                                                    fontWeight: 'normal',
                                                },
                                                props: {
                                                    trigger: 'hover',
                                                    content: '统计时间内订购此商品分类总金额（商品促销及订单优惠/特价按商品优惠后价格计算）',
                                                    offset: 6,
                                                }
                                            },
                                            [
                                                h('Icon',
                                                    {
                                                        style: {
                                                            fontSize: '16px',
                                                            color: '#c4c6cc',
                                                            cursor: 'pointer'
                                                        },
                                                        props: {
                                                            type: 'md-help-circle'
                                                        }
                                                    }
                                                )
                                            ]
                                        )
                                    ]
                                    
                                )
                    }
                },
                {
                    align: 'center',
                    title: '数量占比',
                    key: 'numbili',
                    render: (h, params) => {
                        return h('span', params.row.numbili + '%')
                    }
                },
                {
                    align: 'center',
                    title: '金额占比',
                    key: 'costbili',
                    render: (h, params) => {
                        return h('span', params.row.costbili + '%')
                    }
                }
            ],
            infolist: [], // 表格列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            if (!this.$store.state.openmall) {
                this.tloading = true
                this.http.post(api.statisticsclassify,
                    {
                        starttime: this.stardatetiem,
                        endtime: this.enddatetiem,
                        page: this.pagecurrent,
                        pagesize: this.pagesize,
                    }
                )
                .then(response => {
                    console.log(response.data.msg)
                    this.infolist = response.data.msg.goodscattj
                    this.pagetotal = response.data.msg.goodscattj_pagecontent.num
                    this.tloading = false
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        orderjump (sign) { // 跳转链接
            let link
            if (sign == 1) {
                link = '/OrderGoodSummary'
            } else if (sign == 2) {
                link = '/OrderStatistics'
            } else if (sign == 3) {
                link = '/ClassifyStatistics'
            } else if (sign == 4) {
                link = '/BrandStatistics'
            }
            this.$router.push(link)
        },
        starChange (e) { // 搜索订单开始时间
            let yes = new Date(e) > new Date(this.enddatetiem)
            if (yes) {
                this.$Message.error('开始时间不能大于结束时间')
                this.stardatetiem = ''
                setTimeout(() => { this.stardatetiem = (dates.getFullYear() + '-01-01') }, 0)
            } else {
                this.stardatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            }
        },
        endChange (e) { // 搜索订单结束时间
            let yes = new Date(e) < new Date(this.stardatetiem)
            
            if (yes) {
                this.$Message.error('结束时间不能小于开始时间')
                this.enddatetiem = ''
                setTimeout(() => { this.enddatetiem = (dates.getFullYear() + '-' + (dates.getMonth() + 1 < 10 ? ('0' + (dates.getMonth() + 1)) : (dates.getMonth() + 1)) + '-' + dates.getDate()) }, 0)
            } else {
                this.enddatetiem = e
                this.pagecurrent = 1
                this.getInfo()
            }
        },
        orderdownclick () { // 导出表格
            window.open(this.getWebsite() + api.statclassifyupload + '&shopid=' + this.getCookie('cook_ShopId') + '&cus_uid=' + this.getCookie('cook_cus_uid') + '&cus_pwd=' + this.getCookie('cook_cus_pwd') + '&starttime=' + this.stardatetiem + '&endtime=' + this.enddatetiem + '&op=export_csv')
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        let stardate, endate
        stardate = this.getThirtyDateTime().split(' ')
        endate = this.getDateTime().split(' ')
        this.stardatetiem = stardate[0]
        this.enddatetiem = endate[0]
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/statistics/classifystatistics.vue